import React from "react";
import InscriptionInput from "./InscriptionInput";
import Grades from "./Grades";
import {DegreesQuery} from "../apollo/queries/DegreesQuery";
import CiberAlerts, {MESSAGES} from "../util/Messages";
import {calculateAge, getDeviceId} from "../util/Utils";
import {Mutation} from "@apollo/react-components";
import {InscriptionMutation} from "../apollo/mutations/InscriptionMutation";
import ModalDateCorrection from "./ModalDateCorrection";
import DocumentTypes from "./DocumentTypes";
import DatePicker from "react-date-picker";
import FinalStep from "./FinalStep";
import Spinner from "react-bootstrap/Spinner";



export default class InscriptionForm extends React.Component {

  constructor(props) {
    super(props);
    const institution = JSON.parse(sessionStorage.getItem('institution'));
    this.state = {
      institution: institution.colorScheme,
      showModal: false,
      toInscription: true,
      documentNumber: '',
      documentType: '',
      name: '',
      contactPhone: '',
      contactName: '',
      lastName: '',
      birthDate: '',
      age: '',
      responsibleDocumentNumber: '',
      responsibleDocumentType: '',
      responsibleName: '',
      responsibleLastName: '',
      isResponsible: {
        label: 'Si',
        value: true,
      },
      grade: {
        value: {
          levelId: '',
          programId: '',
          degreeId: '',
        }
      },
      validationCollector:[]
    }
  }

  setError(error) {
    this.setState({
      errorMessage: error
    });
  }

  handleChange = (e, label) => {
    if (label) {
      this.setState({
        [label]: e
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  };


  closeModal = () => {
    this.setState({
      showModal: false
    })
  };

  openModal = () => {
    this.setState({
      showModal: true
    })
  };

  onChangeBirthDate = (date) => {
    let age = calculateAge(date)
    if (age < 18) {
      this.setState({
        isResponsible: {
          value: false,
          label: 'No'
        }
      });
    }
    this.setState({
      birthDate: date,
      age: age
    });
  };

  collectValidations = (field, isValid) => {
    this.setState({
      validationCollector: this.state.validationCollector.filter(function (fieldList) {
        return fieldList !== field
      })
    }, () => {
      if (!isValid) {
        this.setState(prevState => ({
          validationCollector: [...prevState.validationCollector, field]
        }))
      }
    });
  }


  isValid = () => {
    console.log(this.state.grade);
    return this.state.validationCollector.length === 0 &&
      this.state.name && this.state.lastName && this.state.documentNumber && this.state.documentType.value && this.state.grade.value.description && this.state.birthDate &&
      (this.state.isResponsible.value ||
        (!this.state.isResponsible.value && this.state.responsibleName && this.state.responsibleLastName &&
          this.state.responsibleDocumentNumber && this.state.responsibleDocumentType.value));
  }

  render() {
    return (
      <div className="card card-signin my-5 col-sm-6 border-left-0">
        <div className="card-body">
          <h1 className="card-title text-center">Inscripción a {this.state.institution.institutionName}</h1>
          {this.state.errorMessage ?
            <CiberAlerts error={this.state.errorMessage} callBack={this.openModal}/> :
            null
          }
          <Mutation mutation={InscriptionMutation}
            variables={this.state.toInscription ? {
              dataInscription: {
                affiliateName: this.state.isResponsible.value ? this.state.name : this.state.responsibleName,
                affiliateLastName: this.state.isResponsible.value ? this.state.lastName : this.state.responsibleLastName,
                affiliateDocType: this.state.isResponsible.value ? this.state.documentType.value : this.state.responsibleDocumentType.value,
                affiliateDocument: this.state.isResponsible.value ? this.state.documentNumber : this.state.responsibleDocumentNumber,
                beneficiaryDocType: this.state.documentType.value,
                beneficiaryDocument: this.state.documentNumber,
                beneficiaryName: this.state.name,
                beneficiaryLastName: this.state.lastName,
                levelId: this.state.grade.value.levelId,
                programId: this.state.grade.value.programId,
                degreeId: this.state.grade.value.degreeId,
                birthDate: this.state.birthDate,
                deviceId: getDeviceId(),
                institutionId: this.state.institution.institutionId,
                scheduleId: this.state.institution.scheduledId,
              }
            } : {
              dataInscription: {
                institutionId: this.state.institution.institutionId,
                scheduleId: this.state.institution.scheduledId,
                affiliateName: this.state.isResponsible.value ? this.state.name : this.state.responsibleName,
                affiliateLastName: this.state.isResponsible.value ? this.state.lastName : this.state.responsibleLastName,
                affiliateDocType: this.state.isResponsible.value ? this.state.documentType.value : this.state.responsibleDocumentType.value,
                affiliateDocument: this.state.isResponsible.value ? this.state.documentNumber : this.state.responsibleDocumentNumber,
                beneficiaryDocType: this.state.documentType.value,
                beneficiaryDocument: this.state.documentNumber,
                birthDate: this.state.birthDate,
                beneficiaryName: this.state.name,
                beneficiaryLastName: this.state.lastName,
                contact: this.state.contactName,
                phoneContact: this.state.contactPhone,
                deviceId: getDeviceId()
              }
            }}
            onError={(error) => {
              this.setState({
                errorMessage: error
              })
            }}>
            {(confirmInscription, result) => {

              if (result.data && result.data.saveInscriptionCiber && result.data.saveInscriptionCiber.statusCode === "CIB-GEN-0200") {
                if (result.data.saveInscriptionCiber.redirectUrl) {
                  window.location.replace(result.data.saveInscriptionCiber.redirectUrl)
                } else {
                  return <FinalStep message={MESSAGES["SUCCESS"]} title="Inscripcion Cibercolegios"
                    internal={true}/>
                }
              }

              const confirmDate = () => {
                this.closeModal();
                this.setState({
                  errorMessage: '',
                  toInscription: false
                }, () => {
                  return confirmInscription()
                });
              };

              return (
                <>
                  <DocumentTypes handleChange={this.handleChange} documentType={this.state.documentType}
                    label="Tipo de documento del aspirante" name="documentType"/>
                  <InscriptionInput value={this.state.documentNumber} label="N° de documento del aspirante"
                    name="documentNumber" handleChange={this.handleChange} validation="alphanumeric" collectValidations={this.collectValidations}/>
                  <InscriptionInput value={this.state.name} label="Nombres del aspirante" name="name"
                    handleChange={this.handleChange} validation="text" collectValidations={this.collectValidations}/>
                  <InscriptionInput value={this.state.lastName} label="Apellidos del aspirante" name="lastName"
                    handleChange={this.handleChange} validation="text" collectValidations={this.collectValidations}/>
                  <label className="form-label-custom">Fecha de Nacimiento</label><br/>
                  <DatePicker onChange={this.onChangeBirthDate} value={this.state.birthDate}
                    maxDate={new Date()}/><br/>
                  <InscriptionInput value={this.state.age} label="Edad" readOnly={true}/>
                  <Grades grade={this.state.grade} service={DegreesQuery}
                          variables={{institutionId: this.state.institution.institutionId, scheduleId: this.state.institution.scheduledId}}
                    index="degreesInscription" handleChange={this.handleChange}
                  />



                  <DocumentTypes handleChange={this.handleChange} documentType={this.state.responsibleDocumentType}
                    label="Tipo de Documento del acudiente principal" name="responsibleDocumentType"/>
                  <InscriptionInput value={this.state.responsibleDocumentNumber}
                    label="N° de documento del acudiente principal" name="responsibleDocumentNumber"
                    handleChange={this.handleChange} validation="alphanumeric" collectValidations={this.collectValidations}/>
                  <InscriptionInput value={this.state.responsibleName} label="Nombres del acudiente principal"
                    name="responsibleName" handleChange={this.handleChange} validation="text" collectValidations={this.collectValidations}/>
                  <InscriptionInput value={this.state.responsibleLastName} handleChange={this.handleChange}
                    label="Apellidos del acudiente principal" name="responsibleLastName" validation="text" collectValidations={this.collectValidations}/>
                  <br/>

                  <button className="btn btn-lg btn-primary btn-block" type="button"
                    onClick={confirmInscription}
                    disabled={!this.isValid()}
                  >
                    Diligenciar Inscripción {result.loading ? <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner> : ""}
                  </button>
                  <ModalDateCorrection
                    show={this.state.showModal}
                    handleClose={this.closeModal}
                    date={this.state.birthDate}
                    onChange={this.onChangeBirthDate}
                    callBack={confirmDate}
                    withContactInfo={true}
                    contactName={this.state.contactName}
                    contactPhone={this.state.contactPhone}
                    onChangeContact={this.handleChange}
                  />
                </>
              )

            }}
          </Mutation>
        </div>
      </div>
    )
  }
}
